<template>
	<div>
		<loading v-if="!loaded"/>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអតិថិជន</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-66">
						<md-field>
							<label>ឈ្មោះអតិថិជន *</label>
							<md-input type="text" v-model="client.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>ភេទ *</label>
							<md-select placeholder="ភេទ *" v-model="client.gender">
								<md-option value="f">ស្រី</md-option>
								<md-option value="m">ប្រុស</md-option>
								<md-option value="o">ផ្សេងៗ</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ថ្ងៃខែឆ្នាំកំណើត *</label>
							<md-input type="text" v-model="client.dob"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>លេខអត្តសញ្ញាណប័ណ្ណ *</label>
							<md-input type="text" v-model="client.id_card"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>លេខទូរស័ព្ទ *</label>
							<md-input type="text" v-model="client.phone"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>មុខរបរ *</label>
							<md-input type="text" v-model="client.occupation"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>អាសយដ្ឋាន</label>
							<md-input type="text" v-model="client.address">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់ចំណាំ</label>
							<md-input type="text" v-model="client.note">
							</md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name).length > 0">{{client.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ភេទ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.gender).length > 0 && client.gender == 'm'">ប្រុស</span>
								<span v-else-if="String(client.gender).length > 0 && client.gender == 'f'">ស្រី</span>
								<span v-else-if="String(client.gender).length > 0 && client.gender == 'o'">ផ្សេងទៀត</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ថ្ងៃខែឆ្នាំកំណើត</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>មុខរបរ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខអត្តសញ្ញាណប័ណ្ណ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>អាសយដ្ឋាន</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.address).length > 0">{{client.address}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់ចំណាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.note).length > 0">{{client.note}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateClient()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getClient();

		},
		data() {
			return {
				loaded: false,
				client: {
					valid: false,
					name: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: ""
				}
			}
		},
		methods: {
			updateClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/update", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អតិថិជនត្រូវបានធ្វើបច្ចប្បន្នភាពជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/clients");
					}
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0
					&& String(this.client.phone).length > 0 && String(this.client.gender).length > 0
					&& String(this.client.dob) && String(this.client.id_card) && String(this.client.occupation)) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash).then(data => {
					// console.log(data.body.data);
					this.client = data.body.data
					this.loaded = true;
				})
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Edit.vue